import {
  ServerActionWidget,
  SPI,
  ActionWidget,
  ActionType,
  ClickResult,
  RuntimeServerAction,
  SubmitValue
} from '@kunlun/dependencies';

/**
 * 经销商开票单 - 确认按钮 Action Widget
 * 绑定后端 BillingBillConfirmAction.confirm
 * 同时支持基础模型 + 三端代理模型
 */
@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: ActionType.Server,
    name: 'confirm',
    model: ['deli.aries.settlement.BillingBill']
  })
)
@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: ActionType.Server,
    name: 'confirm',
    model: ['deli.aries.platform.DeliAriesPlatformBillingBill']
  })
)
@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: ActionType.Server,
    name: 'confirm',
    model: ['deli.aries.seller.DeliAriesSellerBillingBill']
  })
)
@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: ActionType.Server,
    name: 'confirm',
    model: ['deli.aries.distributor.DeliAriesDistMallBillingBill']
  })
)
export class ConfirmBillingActionWidget extends ServerActionWidget {
  protected executeAction(
    action: RuntimeServerAction,
    submitValue: SubmitValue
  ): Promise<ClickResult> {
    const submitValueCopy = { ...submitValue };
    submitValueCopy.records = this.activeRecords?.[0] ?? {};
    return super.executeAction(action, submitValueCopy);
  }

  protected clickActionAfter(result: ClickResult): Promise<ClickResult> {
    return super.clickActionAfter(result);
  }
}
